import React from "react";
import { FiTag } from "react-icons/fi";
import { formatCurrency } from "@/utils/format";

interface SavingsCalculatorProps {
  originalPrice?: number;
  currentPrice: number;
  discount?: number;
  className?: string;
}

const SavingsCalculator: React.FC<SavingsCalculatorProps> = ({
  originalPrice,
  currentPrice,
  discount,
  className = "",
}) => {
  const hasDiscount = originalPrice && originalPrice > currentPrice;
  const savings = hasDiscount ? originalPrice - currentPrice : 0;
  const discountPercentage =
    discount || (hasDiscount ? Math.round((savings / originalPrice) * 100) : 0);

  if (!hasDiscount) return null;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <FiTag className="text-green-600" />
      <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
        <span className="text-sm font-medium text-gray-900">Save {formatCurrency(savings)}</span>
        {discountPercentage > 0 && (
          <span className="text-xs text-green-600 font-semibold">({discountPercentage}% OFF)</span>
        )}
      </div>
    </div>
  );
};

export default SavingsCalculator;
